import { render, staticRenderFns } from "./SettingsQrCode.vue?vue&type=template&id=30716c39&"
import script from "./SettingsQrCode.vue?vue&type=script&lang=js&"
export * from "./SettingsQrCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports